import { render } from "./HomeSettings.vue?vue&type=template&id=239b6a20"
import script from "./HomeSettings.vue?vue&type=script&lang=js"
export * from "./HomeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__